<template>
  <div class="house-task">
    <el-dialog title="房产变更任务" :visible.sync="visible" width="1000px" @close="onClose">
      <div class="house-tree-list-header">
        <el-button size="mini" type="primary" @click="getList()">更新列表</el-button>
        <el-select size="mini" v-model="where.status" placeholder="状态" clearable @change="pageChange(1)" style="width: 80px;">
          <el-option label="待处理" value="0"></el-option>
          <el-option label="进行中" value="1"></el-option>
          <el-option label="已完成" value="2"></el-option>
        </el-select>
        <el-input size="mini" v-model="where.name" placeholder="任务名称" @change="pageChange(1)" style="width: 200px;"></el-input>
        <el-input size="mini" v-model="where.user_name" placeholder="操作人" @change="pageChange(1)" style="width: 200px;"></el-input>
        <el-date-picker size="mini" v-model="where.start_time" type="date" placeholder="开始时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="pageChange(1)"></el-date-picker>
        <el-date-picker size="mini" v-model="where.end_time" type="date" placeholder="结束时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="pageChange(1)"></el-date-picker>
      </div>
      <div class="house-tree-list-body">
        <el-table
          :data="pageData.data"
          v-loading="loading"
          border
          style="width: 100%" height="60vh">
          <el-table-column
            fixed
            prop="name"
            label="任务名称"
            width="320">
          </el-table-column>
          <el-table-column
            prop="total"
            label="进度/总数"
            width="120">
            <template slot-scope="scope">
              {{scope.row.value}} / {{scope.row.total}}
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
            label="进度"
            width="300">
            <template slot-scope="scope">
              <div class="progress">
                <el-progress :percentage="percentage(scope.row.value,scope.row.total)" :status="statusText(scope.row.status)"></el-progress>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            width="100">
            <template slot-scope="scope">
              <span style="color: #409eff" v-if="scope.row.status==0">待处理</span>
              <span style="color: #67c23a" v-if="scope.row.status==1">进行中</span>
              <span style="color: #909399" v-if="scope.row.status==2">已完成</span>
              <span style="color: #f56c6c" v-if="scope.row.status==3">已取消</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="操作人"
            width="100">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
            width="150">
          </el-table-column>
        </el-table>
      </div>
      <div class="house-tree-list-footer">
        <el-pagination
          layout="prev, pager, next"
          :total="pageData.total"
          :current-page="pageData.current_page"
          :page-size="pageData.per_page"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from "../../../common/Http";

export default {
  name: "HouseTask",
  data() {
    return {
      visible: false,
      loading: false,
      where: {
        project_id: "",
        name:"",
        status: "",
        user_name:"",
        start_time:"",
        end_time:""
      },
      pageData: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1,
        data: [],
      },
      interval:null,
    };
  },
  methods: {
    show(project_id) {
      const that=this;
      that.where.project_id = project_id;
      that.visible = true;
      that.getList();
      that.interval=setInterval(() => {
        that.getList();
      },5000);
    },
    onClose() {
      this.visible = false;
      this.where={
        project_id: "",
        name:"",
        status: "",
        user_name:"",
        start_time:"",
        end_time:""
      };
      this.pageData= {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1,
        data: [],
      };
      clearInterval(this.interval);
      this.interval=null;
    },
    getList(){
      const that = this;
      if(!that.where.project_id){
        return;
      }
      that.loading=true;
      Http.post("HouseTree/getHouseTaskList",{
        ...that.where,
        page:that.pageData.current_page,
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=Object.assign({
            total: 0,
            per_page: 20,
            current_page: 1,
            last_page: 1,
            data: [],
          },ret.data);
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    pageChange(page=1){
      const that=this;
      that.pageData.current_page=page;
      that.getList();
    },
    percentage(value,total){
      if(total===0){
        return 0;
      }
      return ((value/total)*100).toFixed(2)*1;
    },
    statusText(status){
      if(status===0){
        return "";
      }else if(status===1){
        return "warning";
      }else if(status===2){
        return "success";
      }else {
        return "exception";
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.house-task {
  .house-tree-list-header {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
  }
  .house-tree-list-footer{
    text-align: center;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/components/HouseTask.vue